import React from 'react'

interface DetailsIconProps {
  className?: string
  size?: number
  onClick?: () => void
}

export function DetailsIcon({
  className = '',
  size = 20,
  onClick,
}: DetailsIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      onClick={onClick}
    >
      {/* 文档外框 */}
      <rect
        x="4"
        y="3"
        width="16"
        height="18"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
      />
      {/* 文档中的第一行文字 */}
      <rect x="7" y="7" width="10" height="2" rx="1" fill="currentColor" />
      {/* 文档中的第二行文字 */}
      <rect x="7" y="12" width="7" height="2" rx="1" fill="currentColor" />
    </svg>
  )
}
